var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-popover",
    {
      attrs: {
        trigger: "click",
        placement: "left",
        overlayClassName: "no-padding",
      },
      model: {
        value: _vm.attributePickerVisible,
        callback: function ($$v) {
          _vm.attributePickerVisible = $$v
        },
        expression: "attributePickerVisible",
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "content" }, slot: "content" },
        [
          _c("AttributePicker", {
            attrs: {
              "default-selected": null,
              pick: _vm.onAttributePicked,
              "filter-mode": true,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "message-filter-adder",
          class: { "d-none": !_vm.visible },
        },
        [
          _c("span", { staticClass: "icon material-icons" }, [
            _vm._v(" filter_alt "),
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("chatbotv2.addFilter")))]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }